import { useEffect, useState } from "react";
import { ServicePageShell } from "@/components/ServicePageShell";
import api from "@/lib/api";

export default function EcoleDoctorale() {
  const [news, setNews] = useState([]);
  useEffect(() => {
    api.get("/news?limit=3").then((r) => setNews(r.data)).catch(() => {});
  }, []);
  return (
    <ServicePageShell
      contentKey="service.ecole_doctorale"
      defaultContent={{
        eyebrow: "Service administratif",
        title: "École doctorale de l'UNISIC",
        banner_image: "/media/hero-university.jpg",
        intro: "Former les chercheurs qui penseront la communication de demain.",
      }}
      actionButtons={[
        { to: "/plateformes/depots", label: "Déposer un travail de recherche" },
        { to: "/plateformes/archives-academiques", label: "Consulter le Dépôt institutionnel" },
      ]}
      news={news}
    />
  );
}
